import { render, staticRenderFns } from "./jianliDetail.vue?vue&type=template&id=a5d95e1c&scoped=true&"
import script from "./jianliDetail.vue?vue&type=script&lang=js&"
export * from "./jianliDetail.vue?vue&type=script&lang=js&"
import style0 from "./jianliDetail.vue?vue&type=style&index=0&id=a5d95e1c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5d95e1c",
  null
  
)

export default component.exports